import styled from 'styled-components';

export const ResetIcon = styled.div<{ $show: boolean }>`
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  cursor: pointer;
`;

export const SearchWrapper = styled.div<{ $focused: boolean; $hasValue: boolean }>`
  display: flex;
  height: 30px;
  border-radius: 5px;
  padding: 5px 10px;
  align-items: center;
  background-color: ${({ $focused, $hasValue }) =>
    $focused || $hasValue ? 'rgba(0, 0, 0, 0.07)' : 'rgba(0, 0, 0, 0.04)'};
  color: ${({ theme }) => theme.baseBlue.a10};

  > div {
    &.iconSearchSmall,
    &.iconCrossInCircle {
      color: ${({ $hasValue, $focused }) =>
        $hasValue || $focused ? 'rgba(78,84,107, 1)' : 'rgba(78,84,107, 0.65)'};
    }
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.07);
    > div {
      &.iconSearchSmall,
      &.iconCrossInCircle {
        color: rgba(78, 84, 107, 1);
      }
    }
  }

  input {
    padding-left: 10px;
    width: 100%;
    font-size: 12px;
    line-height: 20px;
    font-weight: 600;
    background-color: transparent;
    &:focus {
      outline: none;
    }

    &::placeholder {
      color: rgba(78, 84, 107, 0.65);
    }
  }
`;
